import e from "react";
import { c as d, t as l } from "./useKeyDown-88662051.mjs";
import { B as T, a as x } from "./useClickOutside-55c64a80.mjs";
import { V as h } from "./VideoIcon-c13b94d3.mjs";
import { L as H } from "./Link-460da2fc.mjs";
import { B as N } from "./Button-eec2778c.mjs";
import { W as k } from "./Icon-e01b6482.mjs";
import { I as C, a as D } from "./Image-be3826ec.mjs";
import "./index-615eb227.mjs";
import "./LinkContext-0c83848a.mjs";
import "./app-51178863.mjs";
import "./ImageContext-57256dc1.mjs";
const y = "registration", I = "registration__video-container", R = "registration__information", S = "button", u = {
  registration: y,
  registrationVideoContainer: I,
  registrationInformation: R,
  button: S
};
function _(c) {
  const {
    eventStartDate: i,
    eventEndDate: t,
    eventLocation: r,
    eventLink: n,
    translations: o = {},
    locale: a
  } = c, {
    location: g = "Location",
    time: p = "Time",
    link: v = "Register"
  } = o, { textDate: E, isMultiDayEvent: f } = b(
    i,
    t,
    a
  ), m = f ? void 0 : B(i, t, a);
  return /* @__PURE__ */ e.createElement("span", { className: u.registration }, /* @__PURE__ */ e.createElement("div", { className: u.registrationVideoContainer }, /* @__PURE__ */ e.createElement(
    h,
    {
      src: "/static/videos/Icon_Calendar.mp4",
      fallbackImgSrc: "/static/images/Icon_Calendar.svg"
    }
  )), /* @__PURE__ */ e.createElement(
    "dl",
    {
      className: d(
        u.registrationInformation,
        l.textsLeadText
      )
    },
    /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("dt", { style: { display: "none" } }, "Date"), /* @__PURE__ */ e.createElement("dd", { className: l.textsLeadTextBold }, E)),
    m ? /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("dt", null, p, ": "), /* @__PURE__ */ e.createElement("dd", null, m)) : null,
    r ? /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("dt", null, g, ": "), /* @__PURE__ */ e.createElement("dd", null, r)) : null,
    n ? /* @__PURE__ */ e.createElement(H, { href: n, disableLinkTextStyle: !0 }, /* @__PURE__ */ e.createElement(
      N.Secondary,
      {
        asDiv: !0,
        text: v,
        icon: k.ARROW_UP_RIGHT
      }
    )) : null
  ));
}
function b(c, i, t = "en-US") {
  const r = {
    weekday: void 0,
    year: "numeric",
    month: "long",
    day: "numeric"
  }, n = c.toLocaleDateString(t, r), o = i?.toLocaleDateString(t, r), a = o ? n !== o : !1;
  return {
    textDate: a ? `${n} — ${o}` : n,
    isMultiDayEvent: a
  };
}
function B(c, i, t = "en-US") {
  const r = new Intl.Locale(t), n = {
    timeStyle: "short",
    timeZone: "Europe/Helsinki"
  }, o = c.toLocaleTimeString(r, n).toLocaleLowerCase(), a = i?.toLocaleTimeString(r, n).toLocaleLowerCase();
  return !a || a === o ? o : `${o} - ${a}`;
}
const w = "event-hero-block-content", P = "event-hero-title", W = "event-hero", $ = "desktop", A = "hero-wrapper", V = "image-reference", O = "information", G = "registration", M = "event-hero-lead-text", U = "event-hero-description", s = {
  eventHeroBlockContent: w,
  eventHeroTitle: P,
  eventHero: W,
  desktop: $,
  heroWrapper: A,
  imageReference: V,
  information: O,
  registration: G,
  eventHeroLeadText: M,
  eventHeroDescription: U
};
function ne(c) {
  const {
    title: i,
    image: t,
    imageReference: r,
    leadText: n,
    description: o,
    altText: a,
    isLargeDesktop: g,
    locale: p,
    ...v
  } = c, E = d(l.pageHeading, s.eventHeroTitle), f = d(s.imageReference), m = d(
    l.textsComponentTitleBold,
    s.eventHeroLeadText
  ), L = d(
    l.textsLeadText,
    s.eventHeroDescription
  );
  return /* @__PURE__ */ e.createElement(T, { bottomPadding: x.LARGE, topPadding: x.SMALL }, /* @__PURE__ */ e.createElement(T.Content, { className: s.eventHeroBlockContent }, /* @__PURE__ */ e.createElement("h1", { className: E }, i), /* @__PURE__ */ e.createElement("div", { className: s.heroWrapper }, /* @__PURE__ */ e.createElement(
    C,
    {
      className: s.eventHero,
      src: t.imageSrc,
      width: t.width,
      height: t.height,
      altText: a,
      imageLoader: t.imageLoader,
      styling: D.ARTICLE_PAGE_HERO,
      "data-testid": "event-page-hero-image"
    }
  ), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: f,
      "data-testid": "event-hero-image-reference"
    },
    /* @__PURE__ */ e.createElement("p", { itemProp: "citation", className: l.textsCaption }, r)
  )), /* @__PURE__ */ e.createElement(_, { locale: p, ...v }), g ? /* @__PURE__ */ e.createElement("div", { className: s.information }, /* @__PURE__ */ e.createElement("p", { className: m }, n), /* @__PURE__ */ e.createElement("div", { className: L }, o)) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("p", { className: m }, n), /* @__PURE__ */ e.createElement("div", { className: L }, o))));
}
export {
  ne as EventHero
};
//# sourceMappingURL=EventHero.js.map
